import React, { useEffect, useState } from "react";
import { BlockUI, Loader } from "../../components/Loader";
import { ErrorMessage, Field, Formik, useFormikContext } from "formik";
import { getContactId, OptionSet } from "../../tools/utils";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCountries } from "../../hooks/useCountries";
import { useStates } from "../../hooks/useStates";
import { useOrganizationSchema } from "../../schemas/organization";

import {
  IValueOrganization,
  CreateOrganization,
} from "../../types/organization";
import { useCreateOrganisation } from "../../hooks/useCreateOrganization";
import { useOrgType } from "../../hooks/useOrgType";
import { ErrorMessageModal } from "../../components/Modals/ErrorModal";
import { ValidationRefresher } from "../../components/Common/ValidationRefresher";
export const OrganizationForm = ({
  headerMarginTop,
}: {
  headerMarginTop: number;
}) => {

  const { t, i18n } = useTranslation();
  const language = i18n.language;
    const [errorMessage, setErrorMessage] = useState('');
 const orgtype =useOrgType();
 const orgtypeData = orgtype.data?.data.Data || [];
  const contactId = getContactId();
  const countriesQuery = useCountries();
  const countriesData = countriesQuery.data?.data.Data || [];
  const CreateOrganization = useCreateOrganisation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [missingFields, setMissingFields] = useState<string[]>([]);
  const organizationSchema = useOrganizationSchema();
  let CreateOrganisatioObj: CreateOrganization = {
    CandidateManagerId: contactId,
    Name: "",
    Address1: "",
    Address2: "",
    City: "",
    ZipCode: "",
    OtherType: "", 
    CountryId: "", 
    StateId: "", 
    Type: " ",
    LegalName :'',
    WebsiteUrl :'',
     ExtraDetails :'',
  };
  const initialValues: IValueOrganization = {
    Name: "",
    Address1: "",
    Address2: "",
    City: "",
    ZipCode: "",
    OtherType: "", 
    CountryId: "", 
    StateId: "", 
    Type: " ",
    LegalName :'',
    WebsiteUrl :'',
     ExtraDetails :'',
  };

  useEffect(() => {
    // reset();
  }, [language]);

  const States = () => {
    const formik = useFormikContext<any>();
    const statesQuery = useStates(formik.values.CountryId || undefined);
    const statesLoading = statesQuery.isLoading;
    const statesData = statesQuery.data?.data.Data || [];

    return (
      <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
        <label htmlFor="State">
          {t("account.personalForm.state")}{" "}
          <span style={{ color: "#db3a3a" }}>*</span>
        </label>
        {statesLoading && <Loader scale={0.6} fieldset={true} />}
        <Field
          as="select"
          id="State"
          name="StateId"
          disabled={statesLoading || !formik.values.CountryId}
        >
          <option value="">
            {statesLoading
              ? "Loading..."
              : t("account.personalForm.selectState")}
          </option>
          {statesData.map((state) => (
            <option key={state.ProvinceId} value={state.ProvinceId}>
              {state.ProvinceName}
            </option>
          ))}
        </Field>
        <ErrorMessage
          component="div"
          name="StateId"
          className="cco_form_message cco_form_message_error"
        />
      </li>
    );
  };



  return (
    <>
      <div id="main-content" style={{ marginTop: headerMarginTop }}>
        <div className="cco_content_area cco_content_area_0">
          <article className="react-container">
            <div className="cco_section cco_section_0">
              <div className="cco_row cco_row_8">
                <div className="cco_col">
                  <div className="cco_text cco_text_11">
                    <div className="cco_text_inner">
                      <strong>
                        <Link
                          to={"/myCCOpro"}
                          onClick={() => {
                          }}
                        >
                         {t('MyCCOPro.breadcrumb')}
                        </Link>
                      </strong>{" "}
                      {">"}
                     {t('MyCCOPro.CreateOrg.breadcrumb')}
                    </div>
                  </div>
                </div>
              </div>

              <>
                <>
                  <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    validationSchema={organizationSchema}
                    onSubmit={async (values, { setSubmitting }) => {
                      CreateOrganisatioObj = {
                        CandidateManagerId: contactId,
                        Name: values.Name,
                        Type: values.Type,
                        Address1: values.Address1,
                        Address2: values.Address2,
                        City: values.City,
                        ZipCode: values.ZipCode,
                        OtherType: values.OtherType,
                        CountryId: values.CountryId,
                        StateId: values.StateId,
                        LegalName :values.LegalName,
                        WebsiteUrl :values.WebsiteUrl,
                         ExtraDetails :values.ExtraDetails,
                      };
                   
                  CreateOrganization.mutateAsync(CreateOrganisatioObj)
  .then((res) => {
    if (res?.ApiCode === 200) {
      window.location.href = "/myCCOpro";
    } else {
      setErrorMessage(res?.Message || "Unexpected API response");
      setIsModalOpen(true);
    }
  })
.catch((error: any) => {
  const rawMessage = error?.data?.Message || error?.message || "Something went wrong";

  const localizedMessageMap: Record<string, string> = {
    "An organization with the same Name and Legal Name already exists.": t("organization.errors.duplicateNameLegal"),
    "An organization with the same Name already exists.": t("organization.errors.duplicateName"),
    "An organization with the same Legal Name already exists.": t("organization.errors.duplicateLegalName"),
  };

  const localizedMessage = localizedMessageMap[rawMessage] || t("organization.errors.genericError");

  setErrorMessage(localizedMessage);
  setIsModalOpen(true);
  console.error("API error:", error);
})

                    }} 
                  >
                    {({
                      values,
                      handleSubmit,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      handleReset,
                      isValid,
                      dirty,
                      validateForm
                    }) => (
                      <form
                        onReset={handleReset}
onSubmit={(e) => {
  e.preventDefault();
  validateForm().then((validationErrors) => {
                              const missing = Object.keys(validationErrors).filter(
                                field => validationErrors[field]
                              );
                          
                              if (missing.length > 0) {
                                const formattedFields = missing.map(field =>
                                  field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
                                );
                          
                                setMissingFields(formattedFields);
                                setIsModalOpen(true);
                                return;
    }
    handleSubmit(e);
  });
}}

                        className="cco_form"
                      >
                        <>
                         <ValidationRefresher />
                          <div className="cco_row cco_row_2">
                            <div className="cco_col">
                              <ul className="cco_form_fieldset">
                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="ccoOrganizationName">
                                   {t('MyCCOPro.CreateOrg.displayName')}{" "}
                                    <span style={{ color: "#db3a3a" }}>*</span>
                                  </label>
                                  <Field type="text" id="Name" name="Name" />
                                  <ErrorMessage
                                    name={"Name"}
                                    component={"div"}
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>
                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
  <label htmlFor="Type">
{t('MyCCOPro.CreateOrg.orgType')}{" "}
    <span style={{ color: "#db3a3a" }}>*</span>
  </label>
  {orgtype.isLoading && <Loader scale={0.6} fieldset={true} />}
  <Field
    as="select"
    id="Type"
    name="Type"
    disabled={orgtype.isLoading}
  >
    <option value="">
     {orgtype.isLoading
  ? t('MyCCOPro.CreateOrg.loading')
  : t('MyCCOPro.CreateOrg.selectType')}
    </option>
    {orgtypeData.map((orgType) => (
                                      <option
                                        key={orgType.Id}
                                        value={orgType.Id}
                                      >
                                      {t(`MyCCOPro.CreateOrg.orgTypes.${orgType.Name}`)}
                                      </option>
                                    ))}
  </Field>
  <ErrorMessage
    name="Type"
    component="div"
    className="cco_form_message cco_form_message_error"
  />
</li>

                                {orgtypeData.find((type) => type.Id === values.Type)?.Name === "Other" && (
                                  <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                    <label htmlFor="ccoOtherType">
                                     {t('MyCCOPro.CreateOrg.otherType')}{" "}
                                      <span style={{ color: "#db3a3a" }}>
                                        *
                                      </span>
                                    </label>
                                    <Field
                                      type="text"
                                      id="ccoOtherType"
                                      name="OtherType"
                                      required
                                    />
                                    <ErrorMessage
                                      name="OtherType"
                                      component="div"
                                      className="cco_form_message cco_form_message_error"
                                    />
                                  </li>
                                )}
                                    <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="ccoOrganizationlegalName">
                                 {t('MyCCOPro.CreateOrg.legalName')}  {" "}
                                    <span style={{ color: "#db3a3a" }}>*</span>
                                  </label>
                                  <Field type="text" id="LegalName" name="LegalName" />
                                  <ErrorMessage
                                    name={"LegalName"}
                                    component={"div"}
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>
                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="ccoOrganizationWebsite">
                                    {t('MyCCOPro.CreateOrg.website')}{" "}
                                    <span style={{ color: "#db3a3a" }}>*</span>
                                  </label>
                                  <Field type="text" id="WebsiteUrl" name="WebsiteUrl" />
                                  <ErrorMessage
                                    name={"WebsiteUrl"}
                                    component={"div"}
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>
                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="ccoStreet1">
                                    {t('MyCCOPro.CreateOrg.street1')}{" "}
                                    <span style={{ color: "#db3a3a" }}>*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    id="ccoStreet1"
                                    name="Address1"
                                  />
                                  <ErrorMessage
                                    name={"Address1"}
                                    component={"div"}
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>

                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="ccoStreet2">{t('MyCCOPro.CreateOrg.street2')} </label>
                                  <Field
                                    type="text"
                                    id="ccoStreet2"
                                    name="Address2"
                                  />
                                  <ErrorMessage
                                    name={"Address2"}
                                    component={"div"}
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>

                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="CountryId">
                                    {t('MyCCOPro.CreateOrg.country')}{" "}
                                    <span style={{ color: "#db3a3a" }}>*</span>
                                  </label>
                                  {countriesQuery.isLoading && (
                                    <Loader scale={0.6} fieldset={true} />
                                  )}
                                  <Field
                                    as="select"
                                    id="CountryId"
                                    name="CountryId"
                                    disabled={countriesQuery.isLoading}
                                  >
                                    <option value="">
                                      {countriesQuery.isLoading
                                        ? "Loading..."
                                        : t(
                                            "account.personalForm.selectaCountry"
                                          )}
                                    </option>
                                    {countriesData.map((country) => (
                                      <option
                                        key={country.CountryId}
                                        value={country.CountryId}
                                      >
                                        {country.CountryName}
                                      </option>
                                    ))}
                                  </Field>
                                  <ErrorMessage
                                    name="CountryId"
                                    component="div"
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>

                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="ccoCity">
                                    {t('MyCCOPro.CreateOrg.city')}{" "}
                                    <span style={{ color: "#db3a3a" }}>*</span>
                                  </label>
                                  <Field type="text" id="ccoCity" name="City" />
                                  <ErrorMessage
                                    name={"City"}
                                    component={"div"}
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>

                                <States />
                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="ccoFullName">
                                  {t('MyCCOPro.CreateOrg.zipCode')}{" "}
                                    <span style={{ color: "#db3a3a" }}>*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    id="ccoCity"
                                    name="ZipCode"
                                  />
                                  <ErrorMessage
                                    name={"ZipCode"}
                                    component={"div"}
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>
                                <li className="cco_form_fieldset_item">
  <label htmlFor="AdditionalDetails">
 {t('MyCCOPro.CreateOrg.extraDetails')}
  </label>
  <Field
    as="textarea"
    id="ExtraDetailss"
    name="ExtraDetails"
    rows={4}
    className="cco_form_textarea"
   
  />

</li>

                         
                              </ul>
                            </div>
                          </div>
                          <ul
                            className="cco_menu cco_menu_7"
                            style={{ float: "left" }}
                          >
                            <li className="cco_menu_item">
                              <button
                                className="cco_form_submit"
                                type={"submit"}
                              >
                               {t('MyCCOPro.CreateOrg.submit')}
                              </button>
                            </li>
                          </ul>
                     
                        </>
                      </form>
                    )}
                  </Formik>
                </>
              </>
                   <ErrorMessageModal
                            isModalOpen={isModalOpen}
                            toggleModal={() => setIsModalOpen(false)}
                            missingFields={missingFields}
                             errorMessage={errorMessage}
                          />
            </div>
          </article>
        </div>
      </div>

      <BlockUI
        title={
          t('MyCCOPro.CreateOrg.pleaseWait')
        }
        blocking={CreateOrganization.isLoading || CreateOrganization.isSuccess}
      />
    </>
  );
};
